import React from "react"
import styles from "./styles.scss"
import Header, { TYPES, SEARCH_BAR } from "components/Header"
import Footer from "components/Footer"
import Company from "./Company"
import { getCompany, selectCompany } from "data/companies"
import { connect } from "react-redux"
import image from "images/annonsbild.jpg"
import Ad from "components/Ad"

class CompanyShow extends React.Component {
  constructor(props) {
    super(props)

    const { id } = props.match.params
    id && props.getCompany(id)
  }

  componentDidUpdate(prevProps) {
    const { id } = this.props.match.params
    if (id === prevProps.match.params.id) return null;
    id && this.props.getCompany(id)
  }

  render() {
    const { company } = this.props

    return (
      <div className={styles.container}>
        <Header
          headerType={TYPES.DARK_GRAY}
          searchBar={SEARCH_BAR.SHOW_SEARCH_BAR}
        />
        <div className={styles.companyWrapper}>
          {company && <Company company={company} />}
        </div>

        <Footer />
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  company: selectCompany(state, ownProps),
})

export default connect(
  mapStateToProps,
  {
    getCompany,
  }
)(CompanyShow)



// WEBPACK FOOTER //
// src/pages/CompanyShow/index.jsx